import React, { useEffect, useState } from "react";
import Sidebar from "../includes/Sidebar";
import MainHeading from "../includes/MainHeading";
import Footer from "../includes/Footer";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AdminListService from "../../../services/admin-list.service";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import ReactLoading from "react-loading";
import { newGiftAdd } from "../../../schema";

export default function AddGift() {
  const [loading, setLoading] = useState(false);

  const state = useSelector((state) => state.stateVals);
  const { adminAccessToken, admin_id } = state;
  const navigate = useNavigate();
  const [file, setFile] = useState("");

  useEffect(() => {
    if (adminAccessToken) {
    } else {
      navigate("/admin/login", { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  const handleFileChange = async (e) => {
    setFile(e.target.files[0]);
    setFieldValue("image", e.target.value);
  };

  const AddProduct = async (values) => {
    const formData = new FormData();
    if (file !== "") {
      formData.append("image", file);
    }

    formData.append("adminId", parseInt(admin_id));
    formData.append("name", values.title);
    formData.append("points", values.points);
    formData.append("description", values.description);
    formData.append("type", values.type);
    if (values.type === "bestbuy") {
      formData.append("bb_price", values.bb_price);
      formData.append("sku", values.sku);
    }
    setLoading(true);
    try {
      const response = await AdminListService.addGift(formData);

      toast.success(response?.data?.response, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setLoading(false);
      setTimeout(() => {
        navigate("/admin/manage-products", { replace: true });
      }, 1000);
    } catch (err) {
      console.log(err);
      setLoading(false);

      if (
        err?.response?.data?.response &&
        typeof err?.response?.data?.response === "string"
      ) {
        toast.error(err?.response?.data?.response, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.image?.length) {
        toast.error(err?.response?.data?.image[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.model_no?.length) {
        toast.error(err?.response?.data?.model_no[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.item_no?.length) {
        toast.error(err?.response?.data?.item_no[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.type?.length) {
        toast.error(err?.response?.data?.type[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.name?.length) {
        toast.error(err?.response?.data?.name[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (err?.response?.data?.description?.length) {
        toast.error(err?.response?.data?.description[0], {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong, try again", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,

    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      title: "",
      description: "",
      points: "",
      image: "",
      type: "local",
      bb_price: "",
      sku: "",
    },
    validationSchema: newGiftAdd,
    onSubmit: (values) => {
      AddProduct(values);
    },
  });

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />
          <MainHeading heading="Add Product" />

          <div className="mt-4 row">
            <div className="col-md-12 col-12">
              <div className="card dashboard-cards">
                <div className="bg-white  py-3 card-header">
                  <h4 className="mb-0">Add Product </h4>
                </div>
                <div className="card-body">
                  <form className="row" onSubmit={handleSubmit} noValidate>
                    <div className="col-md-6">
                      <div className="input-field-box">
                        <label>
                          Product Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Product Name"
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue("description", e.target.value);
                          }}
                          name="title"
                          value={values.title || ""}
                        />
                        {errors.title && touched.title ? (
                          <span className="text-danger">{errors.title}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-field-box">
                        <label>
                          Points <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Points"
                          onChange={handleChange}
                          name="points"
                          value={values.points || ""}
                          min={0}
                        />
                        {errors.points && touched.points ? (
                          <span className="text-danger">{errors.points}</span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-field-box">
                        <label>
                          Description <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Description"
                          onChange={handleChange}
                          name="description"
                          value={values.description || ""}
                        />
                        {errors.description && touched.description ? (
                          <span className="text-danger">
                            {errors.description}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input-field-box ">
                        <label>Product Type</label>
                        <select
                          className="form-select"
                          onChange={handleChange}
                          name="type"
                          value={values.type || ""}
                        >
                          <option value="local">Local</option>
                          <option value="bestbuy">BestBuy</option>
                        </select>
                      </div>
                    </div>
                    {values.type === "bestbuy" && (
                      <>
                        <div className="col-md-4">
                          <div className="input-field-box">
                            <label>
                              BestBuy Price{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Price"
                              onChange={handleChange}
                              name="bb_price"
                              value={values.bb_price || ""}
                              min={0}
                            />
                            {errors.bb_price && touched.bb_price ? (
                              <span className="text-danger">
                                {errors.bb_price}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input-field-box">
                            <label>
                              SKU <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="SKU"
                              onChange={handleChange}
                              name="sku"
                              value={values.sku || ""}
                              min={0}
                            />
                            {errors.sku && touched.sku ? (
                              <span className="text-danger">{errors.sku}</span>
                            ) : null}
                          </div>
                        </div>
                      </>
                    )}
                    <div className="col-md-12">
                      <div className=" file-area">
                        <input
                          type="file"
                          name="images"
                          id="images"
                          required="required"
                          accept=".png,.jpg,.jpeg,.webp"
                          onChange={handleFileChange}
                        />
                        <div className="file-dummy">
                          <div className="success">
                            Great, your image is selected. Keep on.
                          </div>
                          <div className="default">Choose Image</div>
                        </div>
                      </div>
                      {errors.image && touched.image ? (
                        <span className="text-danger">{errors.image}</span>
                      ) : null}
                    </div>

                    <div className="col-12">
                      <button className="btn btn-primary mt-3" type="submit">
                        Add Product
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      {loading && (
        <ReactLoading
          type="spinningBubbles"
          color="#185791"
          className="bar-loader"
        />
      )}
    </div>
  );
}
